import { createApi } from '@reduxjs/toolkit/query/react'

import { baseApi } from './utils'
import { ContractHireDashboard } from './types'

export const contractHireApi = createApi({
	reducerPath: 'contractHire',
	...baseApi('/contract-hire/'),
	endpoints: builder => ({
		getDashboard: builder.query<ContractHireDashboard, void>({
			query: () => 'dashboard/',
		}),
	}),
})

export const { useGetDashboardQuery } = contractHireApi
